import { FC } from "react";

type CopyIconProps = {
  stroke?: string;
  width?: number;
  height?: number;
  isActive?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const CopyIcon: FC<CopyIconProps> = ({
  stroke = "#232E45",
  width = 26,
  height = 26,
  isActive,
  ...rest
}) => <svg width={width} height={height} {...rest} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5834 14.0834V15.1667C20.5834 18.7415 20.5834 20.5289 19.4727 21.6396C18.3622 22.7501 16.5748 22.7501 13 22.7501H10.8334C7.25852 22.7501 5.4711 22.7501 4.36056 21.6396C3.25 20.5289 3.25 18.7415 3.25 15.1667V13.0001C3.25 9.42527 3.25 7.63785 4.36056 6.52731C5.4711 5.41675 7.25852 5.41675 10.8334 5.41675H11.9167" stroke={isActive ? "#232E45" : stroke ?? "#232E45"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.167 3.25H19.5003C21.0324 3.25 21.7984 3.25 22.2744 3.72595C22.7503 4.2019 22.7503 4.96794 22.7503 6.5V10.8333M21.667 4.33333L11.917 14.0833" stroke={isActive ? "#232E45" : stroke ?? "#232E45"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
